export const TAB_GENERAL = 'general';
export const TAB_SECURITY = 'security';
export const TAB_SSO = 'sso';
export const TAB_NAMES_SETTINGS = [TAB_GENERAL, TAB_SECURITY, TAB_SSO];
export const DEFAULT_TAB_NAME_SETTINGS = TAB_GENERAL;
export const ALLOWED_SSO_USER_TYPES = ['invoiced', 'admin'];
export const ENTITY_ID_RE = /entityID=".+"/gi;
export const X509CERTIFICATE_RE = /<(ds:)?X509Certificate>[\s\S]+<\/(ds:)?X509Certificate>/gm;
